import {
  JobPerformanceActiveJobsResult,
  JobPerformanceDashboardRequest,
  JobPerformanceDashboardResponse,
  JobPerformanceClientRunDetailResult,
  JobPerformanceProjectRunsRequest,
  JobPerformanceProjectRunsResponse,
  JobPerformanceQuarantineResult,
  JobPerformanceSlowReportsResult,
  JobPerformanceStuckInQueueResult,
} from "@app/operations/job-performance/jobPerformanceInterfaces";
import ServiceBase from "@app/shared/serviceBase";

export class JobPerformanceService extends ServiceBase {

  public async getClientFilterOptions(): Promise<{ clientId: number; name: string }[]> {
    return await this.makeGet<{ clientId: number; name: string }[]>('operations/job-performance-clients');
  }

  public async getDashboard(request: JobPerformanceDashboardRequest): Promise<JobPerformanceDashboardResponse> {
    return await this.makePost<JobPerformanceDashboardResponse>('operations/job-performance-dashboard', request);
  }

  public async getProjectRuns(request: JobPerformanceProjectRunsRequest): Promise<JobPerformanceProjectRunsResponse> {
    return await this.makePost<JobPerformanceProjectRunsResponse>('operations/job-performance-project-runs', request);
  }

  public async getZipProjectRuns(request: JobPerformanceProjectRunsRequest): Promise<JobPerformanceProjectRunsResponse> {
    return await this.makePost<JobPerformanceProjectRunsResponse>('operations/job-performance-zip-project-runs', request);
  }

  public async getClientRunDetail(clientId: number, request: JobPerformanceProjectRunsRequest): Promise<JobPerformanceClientRunDetailResult> {
    return await this.makePost<JobPerformanceClientRunDetailResult>(`operations/job-performance-client-run-detail/${clientId}`, request);
  }

  public async getActiveJobs(request: JobPerformanceProjectRunsRequest): Promise<JobPerformanceActiveJobsResult> {
    return await this.makePost<JobPerformanceActiveJobsResult>('operations/job-performance-active-jobs', request);
  }

  public async getQuarantineLog(request: JobPerformanceProjectRunsRequest): Promise<JobPerformanceQuarantineResult> {
    return await this.makePost<JobPerformanceQuarantineResult>('operations/job-performance-quarantine', request);
  }

  public async getStuckInQueueJobs(request: JobPerformanceProjectRunsRequest): Promise<JobPerformanceStuckInQueueResult> {
    return await this.makePost<JobPerformanceStuckInQueueResult>('operations/job-performance-stuck-in-queue', request);
  }

  public async getSlowReports(request: JobPerformanceProjectRunsRequest): Promise<JobPerformanceSlowReportsResult> {
    return await this.makePost<JobPerformanceSlowReportsResult>('operations/job-performance-slow-reports', request);
  }
}
